import React, { useState, useEffect } from 'react';
import { BRAND_NAME } from '../../theme/brand';
import {
    Box,
    HStack,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    useDisclosure,
    Spinner,
    Text,
    Card,
    Center,


} from '@chakra-ui/react'

import { fetchWrapper } from '../../helpers';

import { FaCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Header from '../../components/Header';
import { useLocation } from 'react-router-dom';
import API from '../../helpers/axiosInstance';
import { getApiHeaders, hasPermission } from '../../utils/DefaultFunction';

function MessageParserList({header}) {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [copiedField, setCopiedField] = useState({ id: null, type: null });
    const [customer, setCustomer] = useState([]);
    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const [list, setList] = useState([])
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false);
    const [open, setIsOpen] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState({});

    const customerObj = JSON.parse(localStorage.getItem("customer"))

    const location = useLocation();
    const [permissions, setPermissions] = useState([]);
    const [permissionsLoading, setPermissionsLoading] = useState(true);
    const permParams = location.pathname.replace('/', "");

    const fetchPermissions = async () => {
        setPermissionsLoading(true);
        try {
            const url = `${process.env.REACT_APP_API_URL}/permission/feature/list?slug=${permParams}`;
            const response = await API.get(url, { headers: getApiHeaders() });
            setPermissions(response.data.data || []);
        } catch (error) {
            console.error("Error fetching permissions:", error);
            setPermissions([]);
        } finally {
            setPermissionsLoading(false);
        }
    };
    useEffect(() => {
        fetchPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const parserViewPermission = hasPermission("parser-view", permissions);

    useEffect(() => {
        loadList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCustomer?.id])



    const loadList = async () => {
        setLoading(true)
        const url = `${process.env.REACT_APP_API_URL}/template-parser/list?customer_id=${customerObj.customer_id}`;
        const data = await fetchWrapper.get(url)
        setList(data.data);
        setLoading(false)
    }

    const meEdit = (rs) => {
        setIsOpenEdit(true);
        setData(rs)
        onOpen()
    }
    const AddNewParser = (rs) => {
        setIsOpenEdit(false);
        setData({})
        onOpen()
    }


    const handleCopy = (type, rs) => {
        let textToCopy = "";

        if (type === "parser") {
            textToCopy = rs?.parser_id || "";
        } else if (type === "message_text") {
            textToCopy = rs?.TemplateMessage?.message || "";

        }

        navigator.clipboard.writeText(textToCopy);

        toast.success("Copied to clipboard")
    };


    if (permissionsLoading) {
        return (
            <>
                <Header header={header}/>
                <Center h="400px">
                    <Spinner size="xl" color="blue.500" thickness="4px" />
                </Center>
            </>
        );
    }

    return (
        <>
            <Header header={header}/>
            {loading &&
                <HStack width="100%" h="100vh" top="0" left="0" bg="rgba(204, 204, 204, 0.5)" position="absolute" zIndex="9999" justifyContent="center">
                    <Spinner
                        thickness='4px'
                        speed='0.65s'
                        emptyColor='gray.200'
                        color='blue.500'
                        size='xl'
                    />
                </HStack>
            }
            {parserViewPermission ? (
            <Card className='card-style' style={{ margin: "20px 70px" }} shadow={'xl'}>
                <div className="body_section">




                    <div className="table_section">

                        <TableContainer width="100%">
                            <Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
                                <Thead>
                                    <Tr>
                                        <Th width="20%">Parser ID</Th>
                                        <Th width="20%">{BRAND_NAME} Template Name</Th>
                                        <Th width="100%">{BRAND_NAME} Message</Th>
                                    </Tr>
                                </Thead>
                                {list.length > 0 ? <Tbody fontSize="14px">
                                    {list.map((rs, index) => (
                                        <Tr key={rs?.id || index}>
                                            <Td width="150px">
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <span
                                                        style={{ cursor: 'pointer', color: "#017AFF" }}
                                                        onClick={() => meEdit(rs)}
                                                    >
                                                        {rs?.parser_id}
                                                    </span>
                                                    <FaCopy
                                                        title="Copy Parser ID"
                                                        onClick={() => handleCopy("parser", rs)}
                                                        style={{
                                                            marginLeft: "10px",
                                                            cursor: "pointer",
                                                            fontSize: "1rem",
                                                            color: "#4A5568"
                                                        }}
                                                    />
                                                </div>
                                            </Td>

                                            <Td width="200px">{rs?.TemplateMessage.name}</Td>

                                            <Td width="100%" whiteSpace="normal" maxW="300px">
                                                <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap">
                                                    <Box flex="1" mr={2} wordBreak="break-word">
                                                        {rs?.TemplateMessage?.message}
                                                    </Box>
                                                    <FaCopy
                                                        title="Copy Message"
                                                        onClick={() => handleCopy("message_text", rs)}
                                                        style={{
                                                            cursor: "pointer",
                                                            fontSize: "1rem",
                                                            color: "#4A5568",
                                                            flexShrink: 0,
                                                        }}
                                                    />
                                                </Box>
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody> : <Text>No data found</Text>}
                            </Table>
                        </TableContainer>
                    </div>

                </div >
            </Card>
            ) : (
                <Center h="400px">
                    <Box textAlign="center">
                        <Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
                            No Access
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                            You don't have permission to view this sections.
                        </Text>
                    </Box>
                </Center>
            )}
        </>
    )
}


export default MessageParserList
